import type { ApiClient } from '../client';
import type { BalanceResponse } from './types';

// Backend wraps payload in { result: ... } and does not always return user_id
// (that field is iframe-internal). Adapt here.
export async function getBalance(client: ApiClient): Promise<BalanceResponse> {
  const raw = await client.request<{ result: Partial<BalanceResponse> }>(
    '/loot_machine/api/game_platform/iframe/v1/balance',
    { method: 'GET' },
  );
  const r = raw.result ?? {};
  return {
    balance_cents: r.balance_cents ?? 0,
    currency: r.currency ?? 'USD',
    user_id: r.user_id ?? 0,
  };
}
